







































import { Network } from "@/models/network";
import { makeid } from "@/lib/makeid";
import { notify } from "@/store";
import { defineComponent, ref } from "@vue/composition-api";
import { defaultTonNetwork } from "@/lib/constants";

export default defineComponent({
  setup(_, ctx) {
    const formRef = ref(null);
    const formModel = ref(true);
    const defaultForm = defaultTonNetwork;
    const form = ref({ ...defaultForm });
    const IDRules = ref([v => !!v || "ID is required"]);
    const nameRules = ref([v => !!v || "Name is required"]);

    const submit = () => {
      (formRef.value as any)?.validate();
      if (!formModel.value)
        return notify({
          text: "Please fill out all required fields",
          type: "error",
          duration: 4000
        });
      ctx.emit("submit", form.value);
      form.value = { ...defaultForm };
    };

    return {
      form,
      defaultForm,
      formModel,
      IDRules,
      nameRules,
      formRef,
      submit
    };
  }
});
